import {
  ActionIcon,
  Box,
  Button,
  Flex,
  Group,
  Image,
  LoadingOverlay,
  Modal,
  Pagination,
  Select,
  SimpleGrid,
  Text,
  TextInput,
  Textarea,
  rem,
} from "@mantine/core";
import { DateInput, DatePicker, DatePickerInput } from "@mantine/dates";
import {
  Dropzone,
  FileRejection,
  FileWithPath,
  IMAGE_MIME_TYPE,
  MIME_TYPES,
} from "@mantine/dropzone";
import { isNotEmpty, useForm } from "@mantine/form";
import { modals } from "@mantine/modals";
import { notifications } from "@mantine/notifications";
import { useQueryClient } from "@tanstack/react-query";
import MyError from "components/MyError";
import TableArticles from "components/TableArticles";
import TableCategory from "components/TableCategory";
import config from "config";
import dayjs from "dayjs";
import { ImageIcon, Plus, RotateCcw, Search, Upload, X } from "lucide-react";
import {
  deleteArticle,
  deleteCategory,
  getArticleById,
  getCategoryeById,
  getSelectDropDown,
} from "modules/api";
import { useCategory } from "modules/news/hooks/useCategory";
import { useCreateCategory } from "modules/news/hooks/useCreateCategory";
import { useCreateSport } from "modules/news/hooks/useCreateSport";
import { useEditCategory } from "modules/news/hooks/useEditCategory";
import { useEditSport } from "modules/news/hooks/useEditSport";
import { useSports } from "modules/news/hooks/useSports";
import { SingleSport, SportsParams } from "modules/news/types";
import { useEffect, useState } from "react";
import { formatFileSize } from "utils/FormatFileSize";

interface Values {
  name: string;
  about: string;
  description: string;
  publishedAt: string;
  //   photo: string;
}

interface RequestType {
  name: string;
  shortDescription: string;
  description: string;
  photo?: FileWithPath;
}

const Category = () => {
  const queryClient = useQueryClient();

  const [params, setParams] = useState<SportsParams>({
    from: null,
    to: null,
    search: null,
    page: 1,
    size: 5,
  });
  const [createEditModal, setCreateEditModal] = useState(false);
  const [modalType, setModalType] = useState<"create" | "edit">("create");
  const [sportType, setSportType] = useState("");
  const [sportId, setSportId] = useState<number | null>(null);
  const {
    isSuccess,
    create,
    isLoading: isLoadingCreate,
  } = useCreateCategory({ refetch: handleReset });

  const {
    isSuccess: isSuccessUpdate,
    update,
    isLoading: isLoadingUpdate,
  } = useEditCategory({ refetch: handleReset, id: sportId });
  const [file, setFile] = useState<FileWithPath[]>([]);
  const [fileArt, setFileArt] = useState<FileWithPath | null>(null);
  const [singleSportImg, setSingleSportImg] = useState<string | null>(null);
  const [selectDropDown, setSelectDropDown] = useState([]);
  const [selectDropDown2, setSelectDropDown2] = useState([]);
  const [dropDownId, setDropDownId] = useState("");
  const [dropDownId2, setDropDownId2] = useState("");
  const [singleSportFile, setSingleSportFile] = useState<string | null>(null);
  const [singleSportImgPath, setSingleSportImgPath] = useState<string[]>([]);
  const [deletedPaths, setDeletedPaths] = useState<string[]>([]);
  const [singleSportFilePath, setSingleSportFilePath] = useState<string | null>(
    null
  );
  const form = useForm({
    mode: "uncontrolled",
    initialValues: {
      from: "",
      to: "",
      search: "",
    },

    validate: {
      // email: (value) => (/^\S+@\S+$/.test(value) ? null : "Invalid email"),
    },
  });
  const formCreateSport = useForm({
    mode: "uncontrolled",
    initialValues: {
      nameUz: "",
      nameRu: "",
      nameEn: "",
    },

    validate: {
      nameUz: isNotEmpty("Please fill the field!"),
      nameRu: isNotEmpty("Please fill the field!"),
      nameEn: isNotEmpty("Please fill the field!"),
    },
  });
  const [loadingEdit, setLoadingEdit] = useState(false);
  const { error, fetchSports, isLoading, sports } = useCategory(params);
  const [value, setValue] = useState<Date | any>(null);

  useEffect(() => {
    fetchSports(params);

    console.log("🚀 ~ Sports ~ sports:", sports);
  }, [params]);

  // useEffect(() => {
  //   if (isSuccess) {
  //     handleReset();
  //     onClose();
  //   }
  // }, [isSuccess]);

  // useEffect(() => {
  //   if (isSuccessUpdate) {
  //     handleReset();
  //     onClose();
  //   }
  // }, [isSuccessUpdate]);

  function handleReset() {
    formCreateSport.reset();
    setParams({
      from: null,
      to: null,
      search: null,
      page: 1,
      size: null,
    });
    // queryClient.invalidateQueries({ queryKey: ["sports"] });
    fetchSports(params);
    setFile([]);
    onClose();
  }

  function handleResetForm() {
    form.reset();
    form.setFieldValue("search", "");
    setParams({
      from: null,
      to: null,
      search: null,
      page: 1,
      size: 5,
    });
    // queryClient.invalidateQueries({ queryKey: ["sports"] });
    fetchSports(params);
  }

  const reFetch = () => {
    fetchSports(params);
  };

  const onClose: () => void = () => {
    formCreateSport.reset();
    setFile([]);
    setFileArt(null);
    setValue(null);
    setSingleSportImgPath([]);
    setSingleSportImg(null);
    setSingleSportFile(null);
    setSingleSportFilePath(null);
    setCreateEditModal((prevent) => !prevent);
    setSportType("");
    setDropDownId("");
  };

  const handlePage = (e: any) => {
    setParams((prev) => ({
      ...prev,
      page: e,
    }));
    console.log("🚀 ~ handlePage ~ e:", e);
  };

  const onSubmit = (e: { from: string; to: string; search: string }) => {
    const { from, to, search } = e;

    setParams((prev) => ({
      ...prev,
      ...(from && { from }),
      ...(to && { to }),
      ...(search && { search }),
    }));
  };

  const handleCreate = async () => {
    await getSelectDrowDownFun();

    setCreateEditModal(true);
    setModalType("create");
  };

  async function getSingleSport(id: number) {
    try {
      setLoadingEdit(true);
      setCreateEditModal(true);
      await getSelectDrowDownFun();

      const res = await getCategoryeById(id);
      const data: any = res?.data?.data;
      console.log("🚀 ~ getSingleSporttttttttt ~ data:", data);
      const initialDate = dayjs(data.publishedAt);
      console.log("🚀 ~ getSingleSport ~ initialDate:", data.photoPath);
      formCreateSport.setValues({
        nameUz: data?.name?.uz,
        nameRu: data?.name?.ru,
        nameEn: data?.name?.en,
      });
      setValue(initialDate);
      setSportId(data.id);
    } catch (error: any) {
      notifications.show({
        title: `${error?.data?.message}`,
        message: null,
        color: "red",
      });
      console.log("🚀 ~ getSingleSport ~ error:", error);
    } finally {
      setLoadingEdit(false);
    }
  }

  const handleEdit: (id: number) => void = (id: number) => {
    console.log("Handle edit");
    getSingleSport(id);
    // setSportId(id);
    // setCreateEditModal(true);
    setModalType("edit");
  };

  const getSelectDrowDownFun = async () => {
    try {
      const res = await getSelectDropDown();
      setSelectDropDown(res?.data?.data);
      console.log("res: ", res);
    } catch (error: any) {}
  };

  const handleDelete: (id: number) => void = (id: number) => {
    modals.openConfirmModal({
      title: "Iltimos, harakatingizni tasdiqlang",
      children: <Text size="sm">Ushbu portfolioni o'chirmoqchimisiz?</Text>,
      labels: { confirm: "Xa", cancel: "Yo'q" },
      onCancel: () => console.log("Cancel"),
      onConfirm: () => deleteSportFunc(id),
    });
  };

  const deleteSportFunc = async (id: number | null) => {
    try {
      const res = await deleteCategory(id);
      notifications.show({
        title: `Muvaffaqiyatli oʻchirildi`,
        message: null,
      });
      setParams({
        from: null,
        to: null,
        search: null,
        page: 1,
        size: null,
      });
      fetchSports(params);
    } catch (error) {
      notifications.show({
        title: `Oʻchirishda xato yuz berdi`,
        message: null,
        color: "red",
      });
      console.log("🚀 ~ deleteSport ~ error:", error);
    }
  };

  const deletePhoto = (fileName: string) => {
    setFile((prev) => prev.filter((file) => file.name !== fileName));
  };
  const deleteFile = () => {
    setFileArt(null);
    setSingleSportFile(null);
  };
  // const preview = file ? (
  //   <Box>
  //     <Image
  //       src={URL.createObjectURL(file)}
  //       onLoad={() => URL.revokeObjectURL(URL.createObjectURL(file))}
  //     />
  //     <Button onClick={deletePhoto} fullWidth mt={10} variant="default">
  //       O'chirish
  //     </Button>
  //   </Box>
  // ) : singleSportImg ? (
  //   <Box>
  //     <Image src={`${config.api.baseURL}/storage/files/${singleSportImg}`} />
  //     <Button onClick={deletePhoto} fullWidth mt={10} variant="default">
  //       O'chirish
  //     </Button>
  //   </Box>
  // ) : null;

  const previewFile = fileArt ? (
    <Box mt={20}>
      <Button
        color="green"
        justify="space-between"
        fullWidth
        rightSection={<X onClick={deleteFile} size={14} />}
        variant="light"
      >
        {fileArt.name}
      </Button>
    </Box>
  ) : singleSportFile ? (
    <Box mt={20}>
      <Button
        color="green"
        justify="space-between"
        fullWidth
        rightSection={<X onClick={deleteFile} size={14} />}
        variant="light"
      >
        {singleSportFile}
      </Button>
    </Box>
  ) : null;

  const onDrop = (acceptedFiles: FileWithPath[]) => {
    setFile((prev) => [...prev, ...acceptedFiles]);
  };

  const onReject = (rejectedFiles: FileRejection[]) => {
    const fileSizeInBytes: number = rejectedFiles[0]?.file.size;
    const formattedSize = `${(fileSizeInBytes / 1024 / 1024).toFixed(2)} MB`;

    notifications.show({
      title: "File Rejected",
      message: `File is larger than ${formattedSize}. Maximum size is 10 MB.`,
      color: "red",
    });
  };

  const handleDeleteImgPath = (imagePath: string) => {
    setDeletedPaths((prev) => [...prev, imagePath]);
    setSingleSportImgPath((prev) => prev.filter((path) => path !== imagePath));
  };

  const onSubmitCreateSport = (values: any) => {
    const data: any = {
      nameUz: values?.nameUz,
      nameRu: values?.nameRu,
      nameEn: values?.nameEn,
    };

    modalType === "create" ? create(data) : update(data);
  };

  const onDropArtFile = (file: FileWithPath[]) => {
    setFileArt(file[0]);
  };
  const onRejectArtFile = (file: FileRejection[]) => {
    const fileSizeInBytes: number = file[0]?.file.size;
    const formattedSize: string = formatFileSize(fileSizeInBytes);

    // File is larger than 10485760 bytes
    notifications.show({
      title: `Fayl 20 mb dan katta`,
      message: "20 mb gacha yuklash mumkin",
      color: "red",
    });
  };

  const convertedDataSport: any = selectDropDown?.length
    ? selectDropDown.map((item: any) => {
        return {
          value: item.id.toString(),
          label: item.name,
        };
      })
    : null;

  const convertedDataSport2: any = selectDropDown2?.length
    ? selectDropDown2.map((item: any) => {
        return {
          value: item.id.toString(),
          label: item.name,
        };
      })
    : null;

  const onChangeDropDown = (e: any) => {
    setDropDownId(e);
    console.log("asdasdasd: ", e);
  };
  const onChangeDropDown2 = (e: any) => {
    setDropDownId2(e);
    console.log("asdasdasd: ", e);
  };

  // if (error) return <MyError error={error} />;
  return (
    <div>
      <LoadingOverlay
        visible={isLoading}
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 2 }}
      />
      <Text size="xl">Filters</Text>
      <Flex align={"end"} justify={"space-between"}>
        <Flex align={"end"}>
          <form
            className="flex items-end"
            onSubmit={form.onSubmit((values) => onSubmit(values))}
          >
            <DateInput
              // value={value}
              // onChange={setValue}
              className="mr-2"
              {...form.getInputProps("from")}
              label="From"
              placeholder="Enter date"
            />
            <DateInput
              // value={value}
              // onChange={setValue}
              className="mr-2"
              {...form.getInputProps("to")}
              label="To"
              placeholder="Enter date"
            />
            <TextInput
              label="Search term"
              placeholder="Please enter a search term."
              {...form.getInputProps("search")}
            />
            <Button
              className="mx-2"
              type="submit"
              rightSection={<Search size={14} />}
            >
              Search
            </Button>
            <ActionIcon
              onClick={handleResetForm}
              size={"input-sm"}
              variant="filled"
              aria-label="Settings"
            >
              <RotateCcw size={14} />
            </ActionIcon>
          </form>
        </Flex>
        <Box>
          <Button rightSection={<Plus size={14} />} onClick={handleCreate}>
            Create
          </Button>
        </Box>
      </Flex>

      <Box className="mt-4">
        <TableCategory
          sports={sports?.items}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
        />
        {sports?.meta && (
          <Flex justify={"center"} mt={20}>
            <Pagination
              onChange={handlePage}
              value={sports.meta.page}
              total={sports.meta.totalPage}
            />
          </Flex>
        )}
      </Box>

      <Modal.Root size={"xl"} opened={createEditModal} onClose={onClose}>
        <LoadingOverlay
          visible={loadingEdit}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />
        <Modal.Overlay />
        <Modal.Content>
          <Modal.Header>
            <Modal.Title>
              {modalType === "create" ? "Create category" : "Edit category"}
            </Modal.Title>
            <Modal.CloseButton />
          </Modal.Header>
          <Modal.Body>
            <form
              onSubmit={formCreateSport.onSubmit((values: any) =>
                onSubmitCreateSport(values)
              )}
            >
              <Flex
                gap="md"
                justify="flex-start"
                align="flex-start"
                wrap="wrap"
                direction={"column"}
              >
                <Flex gap={"md"} className="w-full">
                  <TextInput
                    className="w-full"
                    label="Name uz"
                    placeholder="Please enter uz name"
                    {...formCreateSport.getInputProps("nameUz")}
                  />
                  <TextInput
                    className="w-full"
                    label="Name ru"
                    placeholder="Please enter ru name"
                    {...formCreateSport.getInputProps("nameRu")}
                  />
                  <TextInput
                    className="w-full"
                    label="Name en"
                    placeholder="Please enter en name"
                    {...formCreateSport.getInputProps("nameEn")}
                  />
                </Flex>
              </Flex>
              <Flex justify={"end"} mt={20}>
                <Box>
                  <Button variant="default" mr={10} onClick={onClose}>
                    Close
                  </Button>
                  <Button
                    loading={isLoadingCreate}
                    className="mx-2"
                    type="submit"
                  >
                    {modalType === "create" ? "Create" : "Update"}
                  </Button>
                </Box>
              </Flex>
            </form>
          </Modal.Body>
        </Modal.Content>
      </Modal.Root>

      {/* <MyModal
        singlesport={singleSport}
        sportid={sportId}
        type={modalType}
        refetch={reFetch}
        onClose={onClose}
        createEditModal={createEditModal}
      /> */}
    </div>
  );
};

export default Category;
